import React, { Component } from 'react'
import {css} from 'glamor'
import Globals from './../Globals'

import YouTube from 'react-youtube'
import pattern from '../imgs/pattern.png'

const styles = {
	hero: css({
		"position": "relative",
    "top": "73%",
        "bottom": "100%",
        "height": "150%",
    "transform": "translateY(-50%)",
    "MozTransform": "translateY(-50%)",
    "WebkitTransform": "translateY(-50%)",
    "MsTransform": "translateY(-50%)",
    "OTransform": "translateY(-50%)"
	}),
    videoAlign: css({
        "marginLeft": "20%"
    }),
  hero_header: css({
    "fontFamily": Globals.fonts.bold,
    "fontSize": "90px",
    "lineHeight": "1.11",
    "textAlign": "left",
    "color": Globals.colors.white,
    "margin": "0"
  }),
  hero_logo: css({
    "background": `url(${pattern}) no-repeat left`,
    "width": "209px",
    "height": "50px",
    "display": "inline-block",
    paddingRight: '30px'
  }),
  hero_description: css({
    "fontFamily": Globals.fonts.regular,
    "fontSize": "28px",
    "lineHeight": "1.43",
    "textTransform": "uppercase",
    "color": Globals.colors.white
  })
}

const content = {
	title1 : 'Pandora',
	title2: ' the box',
	subtitle1: '',
	subtitle2: 'Just Unleash the Fun!'
}

export default class Hero extends Component {

	render(){


		return(
			<div {...styles.hero}>
        <span {...styles.hero_header}>{content.title1}</span><br/>
        <span {...styles.hero_logo}></span>
        <span {...styles.hero_header}>{content.title2}</span>
        <p {...styles.hero_description}>{content.subtitle1}<br/>{content.subtitle2}</p>

                <div {...styles.videoAlign}>
                    <div className="videoWrapper">
                        <iframe width="640" height="360" src="https://www.youtube.com/embed/Gqgr2VSKa9s?rel=0&hd=1" frameborder="0" allowfullscreen></iframe>
                    </div>
                </div>
      </div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/componentes/Hero.js